import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { SharedModule } from "../@theme/shared/shared.module";
import { AppSharedModule } from "../shared/shared.module";
import { AuthCallbackComponent } from "./auth-callback/auth-callback.component";
import { AppLoginComponent } from "./login/login.component";
import { AccessDeniedComponent } from './access-denied/access-denied.component';



@NgModule({
  declarations: [
    AppLoginComponent,
    AuthCallbackComponent,
    AccessDeniedComponent,
  ],
  imports: [
    CommonModule,

    AppSharedModule,
    SharedModule
  ],
  providers: [],
  exports: [
    AppLoginComponent,
    AuthCallbackComponent,
    AccessDeniedComponent
  ]
})
export class AppAuthModule { }
